import React, { useState } from 'react';
import { useUserContext } from '../store/user_context';
import useAuth from '../auth/useAuth';
import Cookies from 'js-cookie';
import Role from '../utils/enum/role';

const Nav_menu = () => {
    const [showMenu, setShowMenu] = useState(false);
    const { user, setUser } = useUserContext();
    const { hasRole } = useAuth();
    
    const toggleMenu = (event) => {
        event.preventDefault();  // Prevent default anchor behavior
        setShowMenu(prevShowMenu => !prevShowMenu);
    };

    const logout = () => {
        setUser(null);
        Cookies.remove("user_data");
        Cookies.remove("auth_token");
        window.location.href = "/"; // optional: redirect to login
    };

    return (
        <section className="topbar">
            <div className="container">
                <ul>
                    <li className={showMenu === true ? 'dropdown open' : 'dropdown'}>
                        <a href="#" id="show_menu" onClick={toggleMenu}>
                            مرحبًا، {user?.name}<i className="mIcon">&#xf2f9;</i>
                        </a>
                        {showMenu && (
                            <ul className={showMenu === true ? 'dropdown-menu open' : 'dropdown-menu'}>
                                {hasRole([Role.Admin]) && (
                                    <li>
                                        <a href="/admin">إعدادات<i className="mIcon">&#xf1c6;</i></a>
                                    </li>
                                )}
                                {hasRole([Role.Employee,Role.Admin]) && (
                                    <li>
                                        <a href="/employee/orders.archives">أرشيف طلبات الموظف<i className="mIcon">&#xf105;</i></a>
                                    </li>
                                )}
                                <li>
                                    <a onClick={logout}>تسجيل خروج<i className="mIcon">&#xf1af;</i></a>
                                </li>
                            </ul>
                        )}
                    </li>
                </ul>
            </div>
        </section>
    );
};

export default Nav_menu;
